import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const UserFilters = ({ filters, onFiltersChange, onReset }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const hasActiveFilters = filters.search || filters.role || filters.status || filters.is_active;

  const FilterFields = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-muted-foreground">Recherche</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Email, nom, téléphone, ID LogiConnect..."
              value={filters.search || ''}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              className="pl-10"
            />
          </div>
        </div>

        {/* Role Filter */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-muted-foreground">Rôle</label>
          <Select
            value={filters.role || 'all'}
            onValueChange={(value) => handleFilterChange('role', value === 'all' ? '' : value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Tous les rôles" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous les rôles</SelectItem>
              <SelectItem value="CLIENT">Client</SelectItem>
              <SelectItem value="TRANSPORTEUR">Transporteur</SelectItem>
              <SelectItem value="AGENT">Agent</SelectItem>
              <SelectItem value="ADMIN">Administrateur</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Status Filter */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-muted-foreground">Statut</label>
          <Select
            value={filters.status || 'all'}
            onValueChange={(value) => handleFilterChange('status', value === 'all' ? '' : value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Tous les statuts" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous les statuts</SelectItem>
              <SelectItem value="PENDING">En attente</SelectItem>
              <SelectItem value="ACTIVE">Actif</SelectItem>
              <SelectItem value="SUSPENDED">Suspendu</SelectItem>
              <SelectItem value="BANNED">Banni</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Active Filter */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-muted-foreground">Activité</label>
          <Select
            value={filters.is_active || 'all'}
            onValueChange={(value) => handleFilterChange('is_active', value === 'all' ? '' : value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Tous" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous</SelectItem>
              <SelectItem value="true">Actifs uniquement</SelectItem>
              <SelectItem value="false">Inactifs uniquement</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
  );

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      {/* Desktop: Header + Filters always visible */}
      <div className="hidden md:block space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Filter className="h-5 w-5 text-muted-foreground" />
            <h3 className="font-semibold text-foreground">Filtres</h3>
          </div>
          {hasActiveFilters && (
            <Button variant="ghost" size="sm" onClick={onReset}>
              <X className="h-4 w-4 mr-2" />
              Réinitialiser
            </Button>
          )}
        </div>
        <FilterFields />
      </div>

      {/* Mobile: Accordion */}
      <div className="md:hidden">
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="filters" className="border-none">
            <div className="flex items-center justify-between">
              <AccordionTrigger className="py-0 hover:no-underline">
                <div className="flex items-center gap-2">
                  <Filter className="h-5 w-5 text-muted-foreground" />
                  <h3 className="font-semibold text-foreground">Filtres</h3>
                  {hasActiveFilters && (
                    <span className="ml-2 text-xs bg-secondary text-secondary-foreground px-2 py-1 rounded-full">
                      Actifs
                    </span>
                  )}
                </div>
              </AccordionTrigger>
              {hasActiveFilters && (
                <Button variant="ghost" size="sm" onClick={onReset} className="ml-2">
                  <X className="h-4 w-4" />
                </Button>
              )}
            </div>
            <AccordionContent>
              <div className="pt-4">
                <FilterFields />
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default UserFilters;

